import { render, staticRenderFns } from "./CaseDetail.vue?vue&type=template&id=5fc0da82&scoped=true&"
import script from "./CaseDetail.vue?vue&type=script&lang=js&"
export * from "./CaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./CaseDetail.vue?vue&type=style&index=0&id=5fc0da82&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0da82",
  null
  
)

export default component.exports